"use strict";

exports.__esModule = true;
exports.FetchRequest = void 0;
var _fetch_response = require("./fetch_response");
var _request_interceptor = require("./request_interceptor");
var _utils = require("./lib/utils");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var FetchRequest = exports.FetchRequest = /*#__PURE__*/function () {
  function FetchRequest(method, url) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    _classCallCheck(this, FetchRequest);
    this.method = method;
    this.options = options;
    this.originalUrl = url.toString();
  }
  return _createClass(FetchRequest, [{
    key: "perform",
    value: function () {
      var _perform = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var requestInterceptor, response, responseStatusIsTurboStreamable, _t, _t2, _t3;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              requestInterceptor = _request_interceptor.RequestInterceptor.get();
              if (!requestInterceptor) {
                _context.n = 1;
                break;
              }
              _context.n = 1;
              return requestInterceptor(this);
            case 1:
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.error(_t);
            case 3:
              _t2 = _fetch_response.FetchResponse;
              _context.n = 4;
              return window.fetch(this.url, this.fetchOptions);
            case 4:
              _t3 = _context.v;
              response = new _t2(_t3);
              if (!(response.unauthenticated && response.authenticationURL)) {
                _context.n = 5;
                break;
              }
              return _context.a(2, Promise.reject(window.location.href = response.authenticationURL));
            case 5:
              responseStatusIsTurboStreamable = response.ok || response.unprocessableEntity;
              if (!(responseStatusIsTurboStreamable && response.isTurboStream)) {
                _context.n = 6;
                break;
              }
              _context.n = 6;
              return response.renderTurboStream();
            case 6:
              return _context.a(2, response);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function perform() {
        return _perform.apply(this, arguments);
      }
      return perform;
    }()
  }, {
    key: "addHeader",
    value: function addHeader(key, value) {
      var headers = this.additionalHeaders;
      headers[key] = value;
      this.options.headers = headers;
    }
  }, {
    key: "sameHostname",
    value: function sameHostname() {
      if (!this.originalUrl.startsWith('http:')) {
        return true;
      }
      try {
        return new URL(this.originalUrl).hostname === window.location.hostname;
      } catch (_) {
        return true;
      }
    }
  }, {
    key: "fetchOptions",
    get: function get() {
      return {
        method: this.method.toUpperCase(),
        headers: this.headers,
        body: this.formattedBody,
        signal: this.signal,
        credentials: this.credentials,
        redirect: this.redirect
      };
    }
  }, {
    key: "headers",
    get: function get() {
      var baseHeaders = {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': this.contentType,
        Accept: this.accept
      };
      if (this.sameHostname()) {
        baseHeaders['X-CSRF-Token'] = this.csrfToken;
      }
      return (0, _utils.compact)(Object.assign(baseHeaders, this.additionalHeaders));
    }
  }, {
    key: "csrfToken",
    get: function get() {
      return (0, _utils.getCookie)((0, _utils.metaContent)('csrf-param')) || (0, _utils.metaContent)('csrf-token');
    }
  }, {
    key: "contentType",
    get: function get() {
      if (this.options.contentType) {
        return this.options.contentType;
      } else if (this.body == null || this.body instanceof window.FormData) {
        return undefined;
      } else if (this.body instanceof window.File) {
        return this.body.type;
      }
      return 'application/json';
    }
  }, {
    key: "accept",
    get: function get() {
      switch (this.responseKind) {
        case 'html':
          return 'text/html, application/xhtml+xml';
        case 'turbo-stream':
          return 'text/vnd.turbo-stream.html, text/html, application/xhtml+xml';
        case 'json':
          return 'application/json, application/vnd.api+json';
        default:
          return '*/*';
      }
    }
  }, {
    key: "body",
    get: function get() {
      return this.options.body;
    }
  }, {
    key: "query",
    get: function get() {
      var originalQuery = (this.originalUrl.split('?')[1] || '').split('#')[0];
      var params = new URLSearchParams(originalQuery);
      var requestQuery = this.options.query;
      if (requestQuery instanceof window.FormData) {
        requestQuery = (0, _utils.stringEntriesFromFormData)(requestQuery);
      } else if (requestQuery instanceof window.URLSearchParams) {
        requestQuery = requestQuery.entries();
      } else {
        requestQuery = Object.entries(requestQuery || {});
      }
      (0, _utils.mergeEntries)(params, requestQuery);
      var query = params.toString();
      return query.length > 0 ? "?".concat(query) : '';
    }
  }, {
    key: "url",
    get: function get() {
      return this.originalUrl.split('?')[0].split('#')[0] + this.query;
    }
  }, {
    key: "responseKind",
    get: function get() {
      return this.options.responseKind || 'html';
    }
  }, {
    key: "signal",
    get: function get() {
      return this.options.signal;
    }
  }, {
    key: "redirect",
    get: function get() {
      return this.options.redirect || 'follow';
    }
  }, {
    key: "credentials",
    get: function get() {
      return this.options.credentials || 'same-origin';
    }
  }, {
    key: "additionalHeaders",
    get: function get() {
      return this.options.headers || {};
    }
  }, {
    key: "formattedBody",
    get: function get() {
      var bodyIsAString = Object.prototype.toString.call(this.body) === '[object String]';
      var contentTypeIsJson = this.headers['Content-Type'] === 'application/json';
      if (contentTypeIsJson && !bodyIsAString) {
        return JSON.stringify(this.body);
      }
      return this.body;
    }
  }]);
}();